import { useContext } from "react";
import { findIndex } from "lodash";

import { useMutation } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";
import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";

const mutationFactory = () => {
  const query = `mutation updateNextWorkflowSortOrder($targetId: ID!, $placeBeforeItemId: ID) {
          updateNextWorkflowSortOrder(targetId: $targetId, placeBeforeItemId: $placeBeforeItemId) {
            success
          }
    }`;

  const resolver = ({ data: { removeNextWorkflowFromConditionsGroup } }) => {
    return { data: removeNextWorkflowFromConditionsGroup };
  };

  return { query: query, resolver: createResolverFactory(resolver) };
};

export function useUpdateNextWorkflowSortOrder() {
  const mutate = useMutation(mutationFactory);
  const { fireError } = useContext(ToasterContext);

  return (targetId, orderedItems) => {
    const targetIndex = findIndex(orderedItems, {
      id: targetId,
    });
    const placeBeforeItemId = orderedItems[targetIndex + 1]?.id || null;

    return mutate({
      targetId: toGlobalId("NextWorkflow", targetId),
      placeBeforeItemId: placeBeforeItemId
        ? toGlobalId("NextWorkflow", placeBeforeItemId)
        : null,
    })
      .then((resp) => {
        return resp;
      })
      .catch((e) => {
        console.error("Failed to update next workflow sort order", e);
        fireError(
          Array.isArray(e) && e[0]?.message
            ? e[0].message
            : "Failed to update next workflow order, please retry or contact support for assistance",
          e
        );
      });
  };
}

export default useUpdateNextWorkflowSortOrder;
